import $ from 'jquery'

require('intersection-observer');

const initLazyLoading = function(el) {

	var lazyElements = el.find('[data-lazy]:not(.lazy-init)')

	if ("IntersectionObserver" in window) {

		let lazyElementObserver = new IntersectionObserver(function(entries, observer) {
			entries.forEach(function(entry) {
				if (entry.isIntersecting) {
					let lazyElement = $(entry.target);
					if(!lazyElement.data('lazy')) {
						lazyElement = lazyElement.find('[data-lazy]');
					}
					var l = lazyElement.data('lazy');
					lazyElementObserver.unobserve(entry.target);
					lazyElement.attr('data-lazy',null).addClass('lazy-loaded').trigger('lazy-load');
					if(l == "parent") {
						lazyElement.find('[data-lazy]').attr('data-lazy',null).addClass('lazy-loaded').trigger('lazy-load');
					}
				}
			});
		}, {
			rootMargin: "0px 0px 500px 0px"
		});

		lazyElements.each(function() {
			var bg = $(this).closest('[data-bg]');
			var el = bg.length ? bg.get(0) : this;
            var mode = $(this).data('lazy') || 'auto';
            if(mode != "delay") {
                lazyElementObserver.observe(el);
            }
            $(this).addClass('lazy-init');
		});

	}
}

$.fn.lazyLoad = function() {
    return this.each(function() {
        var el = $(this);
        el = el.data('lazy') ? el : el.find('[data-lazy]');
        el.attr('data-lazy',null).addClass('lazy-loaded').trigger('lazy-load');
    });
}

export default {
	init: function(el) {
        if(!el) el = $('body');
		initLazyLoading(el);
	},
    trigger: function(el) {
        el = el.data('lazy') ? el : el.find('[data-lazy]');
        el.attr('data-lazy',null).addClass('lazy-loaded').trigger('lazy-load');
    },

}
